import './Input.css';
import { forwardRef } from 'react';

const TextInputTime = forwardRef((props, ref) => {
    const prefixeClassName = "input"
    return (
        <input {...props} ref={ref} type="time" className={prefixeClassName + (props.className ? " " + props.className : "")}></input>
    )
});

TextInputTime.defaultProps = {
    className: 'full-width',
    type: 'text',
    autoComplete: "chrome-off"
}

export default TextInputTime;